module.exports = require("./../../_gen/starling/rendering/BatchProcessor");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/BatchProcessor.js
// module id = 210
// module chunks = 0